import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { ContextMenu, FatArrowDown, MenuButton } from 'basic-components';
import { Query } from 'dashboard-services';
import { globalActions } from 'primary-components';

import getApiConfig from 'api/ApiConfig';
import { dataSharingQueries } from 'queries/datasharing';

import ProviderIcon from './ProviderIcon';
import ProviderItem from './ProviderItem';
import ProviderLabel from './ProviderLabel';

import { Else, If, Then, When } from 'react-if';

const emptyArray = []
const ProviderSelector = ({ withText, menuOffsetY }) => {
  const dispatch = useDispatch(),
        source = useSelector(state => state.globalState.source),
        getApiConfigLocal = useCallback(() => dispatch(getApiConfig()), [dispatch]),
        onChangeProvider = useCallback(source => dispatch(globalActions.onChange(source, "source")), [dispatch]),
        getQueryBuilder = useCallback(() => 
          new Query.Builder(getApiConfigLocal())
            .withFetching(false)
            .withShouldDisplayError(false)
        , [getApiConfigLocal]),
        { data: providers = emptyArray } = dataSharingQueries.useGetProducers({ 
          getQueryBuilder,
          includeSelfProducer: true,
        }),
        localProvider = useMemo(() => providers.find(p => p.producerId === 0), [providers]),
        activeProvider = useMemo(() => providers.find(p => p.name === source) || {}, [source, providers])

  useEffect(() => {
    if(!source && localProvider?.name) {
      onChangeProvider(localProvider.name)
    }
  }, [localProvider, onChangeProvider, source])

  return (
    <ContextMenu
        className="provider-selector__menu"
        menuButton={(
          <MenuButton key="MenuButton">
            <div className="provider-selector">
              <When condition={withText}>
                {() => (
                  <ProviderLabel/>
                )}
              </When>
              <ProviderIcon activeProvider={activeProvider}/>
              <If condition={withText}>
                <Then>
                  {() => (
                    <div className="provider-selector__name">
                      {activeProvider.readableName}
                    </div>
                  )}
                </Then>
                <Else>
                  {() => (
                    <div className="provider-selector__arrow">
                      <FatArrowDown
                          color="blue-bright"
                          height={12}
                          width={12}
                      />
                    </div>
                  )}
                </Else>
              </If>
            </div>
          </MenuButton>
        )}
        offsetY={menuOffsetY}
    >
      {providers.map(provider => (
        <ProviderItem
            onChangeProvider={onChangeProvider}
            provider={provider}
        />
      ))}
    </ContextMenu>
  )
}

  ProviderSelector.defaultProps = {
    menuOffsetY: undefined,
    withText: true,
  }

  ProviderSelector.propTypes = {
    menuOffsetY: PropTypes.number,
    withText: PropTypes.bool,
  }

export default ProviderSelector;